import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vShow as _vShow, Transition as _Transition, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/list/title.svg'
import _imports_1 from '@/assets/img/list/video.svg'
import _imports_2 from '@/assets/img/list/play.svg'
import _imports_3 from '@/assets/img/list/voteBtn.png'
import _imports_4 from '@/assets/img/list/reVoteBtn.png'
import _imports_5 from '@/assets/img/detail/line_login.svg'
import _imports_6 from '@/assets/img/list/tver.png'
import _imports_7 from '@/assets/img/list/youtube2.png'
import _imports_8 from '@/assets/img/list/back.svg'
import _imports_9 from '@/assets/img/detail/letter.svg'
import _imports_10 from '@/assets/img/detail/voteModalBackBtn.svg'
import _imports_11 from '@/assets/img/detail/voteModalVoteBtn.svg'


const _withScopeId = n => (_pushScopeId("data-v-48b33424"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "date" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "actress/list/08_prof01.jpg?t=002",
  loading: "lazy",
  alt: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "大和 奈央", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "actress/list/09_prof01.jpg?t=002",
  loading: "lazy",
  alt: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "和多田 萌衣", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "actress/list/02_prof01.jpg?t=002",
  loading: "lazy",
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "岸本 小雪", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "actress/list/04_prof01.jpg?t=002",
  loading: "lazy",
  alt: ""
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "坂本 彩", -1))
const _hoisted_12 = {
  key: 0,
  class: "vote"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    id: "video",
    alt: ""
  })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("動画を観て、投票してください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 投票期間内は何回でも変更可能です。")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#726370","font-size":"0.9em"} }, [
    /*#__PURE__*/_createTextVNode("投票期間"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 締め切りました。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 多数の投票ありがとうございました。")
  ])
], -1))
const _hoisted_16 = { class: "video" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "playBtn",
    alt: ""
  })
], -1))
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { style: {"display":"none"} }
const _hoisted_23 = { class: "selectBox" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "plan" }, "「もう一度、会ってみたい」女優は誰？", -1))
const _hoisted_25 = { style: {"display":"flex","margin":"0 12px"} }
const _hoisted_26 = { class: "selectGroup" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rank" }, "1位", -1))
const _hoisted_28 = { class: "selectWrap" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<option disabled value=\"0\" selected data-v-48b33424>候補者を選択</option><option value=\"008\" data-v-48b33424>大和 奈央</option><option value=\"009\" data-v-48b33424>和多田 萌衣</option><option value=\"002\" data-v-48b33424>岸本 小雪</option><option value=\"004\" data-v-48b33424>坂本 彩</option>", 5)
const _hoisted_35 = [
  _hoisted_30
]
const _hoisted_36 = { class: "selectGroup" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rank" }, "2位", -1))
const _hoisted_38 = { class: "selectWrap" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<option disabled value=\"0\" selected data-v-48b33424>候補者を選択</option><option value=\"008\" data-v-48b33424>大和 奈央</option><option value=\"009\" data-v-48b33424>和多田 萌衣</option><option value=\"002\" data-v-48b33424>岸本 小雪</option><option value=\"004\" data-v-48b33424>坂本 彩</option>", 5)
const _hoisted_45 = [
  _hoisted_40
]
const _hoisted_46 = { style: {"display":"flex","margin":"0 12px"} }
const _hoisted_47 = { class: "selectGroup" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rank" }, "3位", -1))
const _hoisted_49 = { class: "selectWrap" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = /*#__PURE__*/_createStaticVNode("<option disabled value=\"0\" selected data-v-48b33424>候補者を選択</option><option value=\"008\" data-v-48b33424>大和 奈央</option><option value=\"009\" data-v-48b33424>和多田 萌衣</option><option value=\"002\" data-v-48b33424>岸本 小雪</option><option value=\"004\" data-v-48b33424>坂本 彩</option>", 5)
const _hoisted_56 = [
  _hoisted_51
]
const _hoisted_57 = { class: "selectGroup" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rank" }, "4位", -1))
const _hoisted_59 = { class: "selectWrap" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = /*#__PURE__*/_createStaticVNode("<option disabled value=\"0\" selected data-v-48b33424>候補者を選択</option><option value=\"008\" data-v-48b33424>大和 奈央</option><option value=\"009\" data-v-48b33424>和多田 萌衣</option><option value=\"002\" data-v-48b33424>岸本 小雪</option><option value=\"004\" data-v-48b33424>坂本 彩</option>", 5)
const _hoisted_66 = [
  _hoisted_61
]
const _hoisted_67 = { class: "error" }
const _hoisted_68 = { class: "error" }
const _hoisted_69 = {
  key: 0,
  class: "voteMessage"
}
const _hoisted_70 = {
  key: 1,
  class: "voteMessage"
}
const _hoisted_71 = { style: {"display":"flex","align-items":"center","justify-content":"center"} }
const _hoisted_72 = {
  key: 1,
  class: "vote"
}
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" 投票はLINEアプリからアクセスしてください。")
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qr_container" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://line.me/R/ti/p/@150ixpdk" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_5 })
  ])
], -1))
const _hoisted_77 = [
  _hoisted_73,
  _hoisted_74,
  _hoisted_75,
  _hoisted_76
]
const _hoisted_78 = {
  key: 2,
  class: "vote"
}
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" 投票はLINEアプリからアクセスしてください。")
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qr_container" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://line.me/R/ti/p/@150ixpdk" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_5 })
  ])
], -1))
const _hoisted_83 = [
  _hoisted_79,
  _hoisted_80,
  _hoisted_81,
  _hoisted_82
]
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://tver.jp/series/sr1p0lzph2",
  class: "youtube_banner",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: ""
  })
], -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.youtube.com/channel/UC9DMV0wVwcucTRgdz99GleQ",
  target: "_blank",
  class: "youtube_banner"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: ""
  })
], -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1))
const _hoisted_87 = { class: "container w600" }
const _hoisted_88 = { class: "youtube" }
const _hoisted_89 = ["src"]
const _hoisted_90 = { class: "container w600" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1.1em","font-weight":"400"} }, "投票期間内は何回でも変更可能です。", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1.1em","font-weight":"400"} }, "投票してよろしいですか？", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  style: {"margin-top":"20px","margin-bottom":"10px"}
}, null, -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"1em"} }, "  ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'Detail', params: { id: '008' }} }, {
            default: _withCtx(() => [
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'Detail', params: { id: '009' }} }, {
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'Detail', params: { id: '002' }} }, {
            default: _withCtx(() => [
              _hoisted_8,
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'Detail', params: { id: '004' }} }, {
            default: _withCtx(() => [
              _hoisted_10,
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ]),
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _hoisted_13,
            _hoisted_14,
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "video-list"
                }, [
                  (item.type==='default' && item.src !== '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", {
                          class: "videoBox",
                          onClick: ($event: any) => (_ctx.openModal(item.src))
                        }, [
                          _createElementVNode("img", {
                            src: item.thumbnail,
                            class: "thumbnail",
                            alt: ""
                          }, null, 8, _hoisted_19),
                          _hoisted_20
                        ], 8, _hoisted_18),
                        _createElementVNode("span", {
                          class: "caption2",
                          innerHTML: item.caption2
                        }, null, 8, _hoisted_21)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.getVote.vote1) = $event)),
                        disabled: _ctx.getVoted,
                        class: _normalizeClass({'selected':_ctx.getVoted, 'selectError': _ctx.errorSelect[0]})
                      }, _hoisted_35, 10, _hoisted_29), [
                        [_vModelSelect, _ctx.getVote.vote1]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("div", _hoisted_38, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.getVote.vote2) = $event)),
                        disabled: _ctx.getVoted,
                        class: _normalizeClass({'selected':_ctx.getVoted, 'selectError': _ctx.errorSelect[1]})
                      }, _hoisted_45, 10, _hoisted_39), [
                        [_vModelSelect, _ctx.getVote.vote2]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createElementVNode("div", _hoisted_49, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.getVote.vote3) = $event)),
                        disabled: _ctx.getVoted,
                        class: _normalizeClass({'selected':_ctx.getVoted, 'selectError': _ctx.errorSelect[2]})
                      }, _hoisted_56, 10, _hoisted_50), [
                        [_vModelSelect, _ctx.getVote.vote3]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _createElementVNode("div", _hoisted_59, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.getVote.vote4) = $event)),
                        disabled: _ctx.getVoted,
                        class: _normalizeClass({'selected':_ctx.getVoted, 'selectError': _ctx.errorSelect[3]})
                      }, _hoisted_66, 10, _hoisted_60), [
                        [_vModelSelect, _ctx.getVote.vote4]
                      ])
                    ])
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_67, "候補者を選択してください", 512), [
                  [_vShow, _ctx.error1]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_68, "1位〜4位は別の候補者を選択してください", 512), [
                  [_vShow, _ctx.error2]
                ])
              ]),
              _createVNode(_Transition, { name: "vote" }, {
                default: _withCtx(() => [
                  (_ctx.getVoted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, "\\ 投票しました /"))
                    : (_ctx.voteReset)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_70, "投票するまでは投票結果は反映されません"))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_71, [
                (! _ctx.getVoted)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _imports_3,
                      class: _normalizeClass({'voteBtn':true, 'disable':_ctx.getVoted}),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ((!_ctx.validate() && !_ctx.getVoted) ? _ctx.confirm_modal=true : false)),
                      alt: ""
                    }, null, 2))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _imports_4,
                      class: _normalizeClass({'voteBtn':true}),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (this.reset($event))),
                      alt: ""
                    }))
              ])
            ])
          ]))
        : (_ctx.isMobile())
          ? (_openBlock(), _createElementBlock("div", _hoisted_72, _hoisted_77))
          : (_openBlock(), _createElementBlock("div", _hoisted_78, _hoisted_83)),
      _hoisted_84,
      _hoisted_85,
      _createVNode(_component_router_link, {
        to: { path: _ctx.backPage},
        class: "backButton"
      }, {
        default: _withCtx(() => [
          _hoisted_86
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          id: "modal",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("iframe", {
                id: "yiframe",
                width: "560",
                height: "315",
                src: _ctx.VideoUrl,
                title: "YouTube video player",
                frameborder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowfullscreen: ""
              }, null, 8, _hoisted_89)
            ])
          ])
        ], 512), [
          [_vShow, _ctx.modal]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "confirm_modal" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          id: "confirm_modal",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.confirm_modal=false))
        }, [
          _createElementVNode("div", _hoisted_90, [
            _hoisted_91,
            _hoisted_92,
            _hoisted_93,
            _hoisted_94,
            _hoisted_95,
            _hoisted_96,
            _createElementVNode("img", {
              src: _imports_10,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.confirm_modal=false))
            }),
            _hoisted_97,
            _createElementVNode("img", {
              src: _imports_11,
              onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.modal=_ctx.confirm_modal=false; this.vote($event);})
            })
          ])
        ], 512), [
          [_vShow, _ctx.confirm_modal]
        ])
      ]),
      _: 1
    })
  ], 64))
}